module.exports = __webpack_public_path__ + "static/img/10.3d4178c.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting602/images/10.png
// module id = iHGN
// module chunks = 4